import React, { useEffect } from 'react'
import { isMobile } from 'react-device-detect'

import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  DcBreadcrumbs,
  DcFlexBox,
  DcTabs,
  PixelDate,
  PixelDiv,
  PixelFactoryContext,
  PixelPageContainer,
  Section,
  SectionContent,
} from 'pixel-base'
import { get } from 'utils/api-routes.util'
import CheckIcon from 'utils/icons/check-icon'
import XmarkIcon from 'utils/icons/xmark-icon'

import Balance from './components/Balance'
import EventSubscriptions, { IPlan } from './components/EventSubscriptions'
import IVRSetting from './components/IVRSetting'
import NotificationHistory from './components/NotificationHistory'
import SMSPlans from './components/SmsPlans'
import TestMessages from './components/TestMessages'
import { IPixelFactory } from '../../../../decl.d'

const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'SMS Subscription',
    active: true,
  },
]
export interface ICommunicationConfig {
  config: {
    REMAINING_BALANCE: number
    CURRENT_PLAN: string
    REMAINING_CREDITS_FOR_PLAN: number
    EXPIRY_DATE: string
    SERVICE_NAME: string
    SUBSCRIBED_AT: string
    CREDIT_CONSUMED: string
    AUTO_NOTIFY: boolean
  }
  current_plan: IPlan
  remaining_credits: number
  auto_status_update: boolean
  ivr_cancel_status: string
  ivr_confirm_status: string
  is_retry: boolean | null
}
const SMSSubecription = () => {
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const smsPlanRef = React.useRef(null)
  const [communicationConfig, setCommunicationConfig] =
    React.useState<ICommunicationConfig>({
      config: {
        REMAINING_BALANCE: 0,
        CURRENT_PLAN: '',
        REMAINING_CREDITS_FOR_PLAN: 0,
        EXPIRY_DATE: '',
        SERVICE_NAME: '',
        SUBSCRIBED_AT: '',
        CREDIT_CONSUMED: '',
        AUTO_NOTIFY: false,
      },
      current_plan: {
        id: 0,
        service: {
          id: 0,
          service_name: '',
          service_description: '',
          is_active: false,
        },
        plan_name: '',
        plan_cost: 0,
        is_active: false,
      },
      remaining_credits: 0,
      auto_status_update: true,
      ivr_cancel_status: '',
      ivr_confirm_status: '',
      is_retry: null,
    })

  const [activeTabs, setActiveTabs] = React.useState<string>('balance')
  const readData = () => {
    showLoader(smsPlanRef)
    get('/communication/config').subscribe((res: any) => {
      const data = res.response?.data
      if (data) {
        setCommunicationConfig({
          ...communicationConfig,
          config: {
            REMAINING_BALANCE: Number(data.balance_available || 0),
            CURRENT_PLAN: data.current_plan.plan.plan_name,
            REMAINING_CREDITS_FOR_PLAN: Number(
              data.current_plan.remaining_credit || 0,
            ),
            EXPIRY_DATE: data.current_plan.expiry_date.date,
            SERVICE_NAME: data.current_plan.plan.service.service_name,
            SUBSCRIBED_AT: data.current_plan.created_at.date,
            CREDIT_CONSUMED: data.current_plan.credit_consumed || 0,
            AUTO_NOTIFY: data.auto_notify ?? false,
          },
          current_plan: data?.current_plan?.plan,
          remaining_credits: data.current_plan.remaining_credit || 0,
          auto_status_update: data?.auto_status_update,
          ivr_cancel_status: data?.ivr_cancel_status,
          ivr_confirm_status: data?.ivr_confirm_status,
          is_retry: data?.is_retry,
        })
      }

      hideLoader(smsPlanRef)
    })
  }
  useEffect(() => {
    readData()
  }, [])

  const subscriptionTabs = {
    balance: { name: 'balance', title: 'Balance', component: <Balance /> },
    smsplans: {
      name: 'smsplans',
      title: 'SMS Plans',
      component: (
        <SMSPlans
          getAllSmsConfig={readData}
          remainingCredits={communicationConfig.remaining_credits}
        />
      ),
    },
    testmessages: {
      name: 'testmessages',
      title: 'Test',
      component: (
        <TestMessages
          planId={communicationConfig.current_plan?.id}
          getAllSmsConfig={readData}
          setActiveTabs={setActiveTabs}
          SMSConfig={communicationConfig.config}
        />
      ),
    },
    eventsubscriptions: {
      name: 'eventsubscriptions',
      title: 'Event Subscriptions',
      component: (
        <EventSubscriptions
          setActiveTabs={setActiveTabs}
          communicationConfig={communicationConfig}
          setCommunicationConfig={setCommunicationConfig}
        />
      ),
    },
    notificationHistory: {
      name: 'notificationHistory',
      title: 'History',
      component: <NotificationHistory />,
    },

    ivrSettings: {
      name: 'ivrSettings',
      title: 'Settings',
      component: (
        <IVRSetting
          data={{
            ivr_cancel_status: communicationConfig.ivr_cancel_status,
            ivr_confirm_status: communicationConfig?.ivr_confirm_status,
            auto_status_update: communicationConfig?.auto_status_update,
            auto_notify: communicationConfig?.config?.AUTO_NOTIFY,
            is_retry: communicationConfig?.is_retry,
          }}
          origin={'tabs'}
        />
      ),
    },
  }

  const formatData = (data: any, key: any) => {
    switch (key) {
      case 'EXPIRY_DATE':
        return <PixelDate color="#8e959b" format="pixelStandard" value={data} />
      case 'SUBSCRIBED_AT':
        return <PixelDate color="#8e959b" format="pixelStandard" value={data} />
      case 'AUTO_NOTIFY':
        return data ? (
          <CheckIcon color="green" size={16} />
        ) : (
          <XmarkIcon color="red" size={16} />
        )

      default:
        return data
    }
  }

  const style = {
    fontSize: '16px',
    fontWeight: '400',
    color: '#8e959b',
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingLeft: '10px',
    // backgroundColor: '#e9ecef78',
  }
  return (
    <>
      <DcFlexBox
        height="60px"
        fontSize="16px"
        style={{
          fontSize: '16px',
          padding: '8px 0px',
          borderBottom: '1px solid #e5e5e5',
        }}
      >
        <DcFlexBox
          justifyContent="space-between"
          alignItems="center"
          padding=".5rem 20px"
        >
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

          <ProfileSection />
        </DcFlexBox>
      </DcFlexBox>

      <PixelPageContainer style={{ padding: '0px' }} isMobile={isMobile}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="auto"
              justifyContent="space-between"
              alignItems="flex-end"
              padding="0px 20px"
            >
              <DcTabs
                size="md"
                variant="simple"
                tabs={Object.keys(subscriptionTabs).map((tabKey) => ({
                  label: subscriptionTabs[tabKey].title,
                  value: tabKey,
                }))}
                activeTab={activeTabs}
                handleChange={(newTab) => setActiveTabs(newTab)}
              />
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ padding: '20px' }} isMobile={isMobile}>
          <DcFlexBox
            width="100%"
            justifyContent="center"
            flexDirection="column"
            backgroundColor="#ffffffd4"
            padding={isMobile ? '10px' : '10px'}
            alignItems="center"
            style={{
              minHeight: '150px',
              borderRadius: `${isMobile ? '0px' : '12px'}`,
              boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.25)',
            }}
            isMobile={isMobile}
            className="smsPlans"
            ref={smsPlanRef}
          >
            <PixelDiv
              style={{
                display: 'grid',
                gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                alignItem: ' center',
                justifyItems: 'center',
              }}
              isMobile={isMobile}
            >
              {Object.keys(communicationConfig.config).map((data, i) => {
                return (
                  <PixelDiv
                    key={i}
                    width="100%"
                    style={{
                      display: 'table',
                      tableLayout: 'fixed',
                      borderSpacing: '0',
                      borderCollapse: 'collapse',
                    }}
                  >
                    <PixelDiv
                      // backgroundColor="#e9ecef"
                      style={{
                        fontWeight: 600,
                        display: 'table-cell',
                        verticalAlign: 'middle',
                        // padding: '10px',
                        width: '50%',
                        color: '#8e959b',
                        fontSize: '16px',
                      }}
                    >
                      {data.replace(/_/g, ' ')}:
                    </PixelDiv>
                    <PixelDiv style={style}>
                      {formatData(communicationConfig.config[data], data)}
                    </PixelDiv>
                  </PixelDiv>
                )
              })}
            </PixelDiv>
          </DcFlexBox>
        </Section>
        <Section isMobile={isMobile}>
          <SectionContent isMobile={isMobile}>
            {subscriptionTabs[activeTabs].component}
          </SectionContent>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default SMSSubecription
